export interface Coord {
  x: number;
  y: number;
}

export interface NamedCoords {
  [key: string]: Coord;
}
//
// export interface AnyCoord {
//   value: Coord | NamedCoords
// }

export type NamedCoordObject = {
  [index: string]: Coord;
};

export type CoordsData = Coord[] | NamedCoords;

export interface PositionObject {
  accepts: string[];
  coords: CoordsData;
  multi: boolean;
  scaleMult: number;
  gapSize: number;
  maxSpread: number;
  multiDirection: number;

  [key: string]: any;
}

export interface PositionsData {
  dims: number[] | undefined;

  [key: string]: PositionObject | any;
}

export const dimsValueDefault = 100;
